<script setup lang="ts">
import store from "@/store";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import { PanelTheme } from "@/common/themes";
import { svgIcon, baseSelect, baseTable } from "@/common/components";

import { evaluationListByMember } from "@/common/api/rest/evaluation";

const { t } = useI18n();
const route = useRoute();

const monthOptions = [];

const accountId = computed(() => route.params.id as string);
const memberId = computed(() => store.getters.user?.member_id as string);

const tableHeader = computed(() => [
  { key: "code", label: "Código" },
  { key: "company", label: "Empresa" },
  { key: "date", label: "Data" },
]);

const tableData = ref([]);

// function fecthData() {
//   evaluationListByMember(accountId.value, memberId.value).then((response) => {
//     console.log(response);
//   });
// }

// onMounted(() => {
//   fecthData();
// });
</script>

<template>
  <panel-theme>
    <section class="home-page">
      <div class="group">
        <div class="box welcome">
          <span> Bem vindo </span>
          <strong>
            {{ store.getters.profile?.first_name }}
          </strong>
        </div>

        <div class="box evaluations">
          <div class="header">
            <div class="title">AVALIAÇÕES</div>
            <base-select :options="[]" />
          </div>
          <div class="time">
            <svg-icon icon="time-b" size="2rem" />
            0h 0m
          </div>
        </div>
      </div>

      <div class="box my-evaluations">
        <div class="header">
          <div class="title">MINHAS AVALIAÇÕES</div>
        </div>
        <baseTable
          :header="tableHeader"
          :data="tableData"
          :options="true"
          :view="true"
          :paginated="false"
          :show-search="false"
          :add="false"
        />
      </div>
    </section>
  </panel-theme>
</template>

<style lang="scss" scoped>
.home-page {
  display: flex;
  flex-direction: column;
  gap: 1.54rem;

  .box {
    width: calc(100% - (1.375rem * 2));
    background: var(--white);
    border-radius: 0.5rem;
    padding: 1.375rem;
  }

  .group {
    display: flex;
    width: 100%;
    flex-direction: row;
    gap: 1.54rem;
  }

  .welcome {
    font-size: 1.25rem;
  }

  .evaluations {
    display: flex;
    width: 37rem;
    flex-direction: column;
    gap: 1rem;

    .header {
      display: grid;
      grid-template-columns: auto 9.5rem;
      gap: 1rem;
      align-items: center;

      .title {
        font-size: 1.25rem;
        font-weight: bold;
        text-transform: uppercase;
      }
    }

    .time {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      font-size: 1.75rem;
      font-weight: bold;
    }
  }

  .my-evaluations {
    .title {
      font-size: 1.25rem;
      font-weight: bold;
      text-transform: uppercase;
    }
  }
}

@media screen and (max-width: 1024px) {
  .home-page {
    .group {
      flex-direction: column;
    }

    .evaluations {
      width: calc(100% - (1.375rem * 2));

      .header {
        grid-template-columns: 1fr 1fr;
      }
    }
  }
}
</style>
